import { render, staticRenderFns } from "./productTraceabilitySheet.vue?vue&type=template&id=567cdc4f&scoped=true"
import script from "./productTraceabilitySheet.vue?vue&type=script&lang=js"
export * from "./productTraceabilitySheet.vue?vue&type=script&lang=js"
import style0 from "./productTraceabilitySheet.vue?vue&type=style&index=0&id=567cdc4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567cdc4f",
  null
  
)

export default component.exports